export default __webpack_public_path__ + "static/media/macbook_2.f397dd25.png";